const ACCOUNT_TAB = {
  USER_PROFILE: 0,
  CHANGE_PASSWORD: 1,
  SUBSCRIPTION: 2,
};

export default ACCOUNT_TAB;
